"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = equals;
var EPSILON = 0.000001;

function equals(a, b) {
  if (Array.isArray(a) && Array.isArray(b)) {
    if (a === b) {
      return true;
    }
    if (a.length !== b.length) {
      return false;
    }
    for (var i = 0; i < a.length; ++i) {
      if (!equals(a[i], b[i])) {
        return false;
      }
    }
    return true;
  }
  return Math.abs(a - b) <= EPSILON * Math.max(1.0, Math.abs(a), Math.abs(b));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9lcXVhbHMuanMiXSwibmFtZXMiOlsiZXF1YWxzIiwiRVBTSUxPTiIsImEiLCJiIiwiQXJyYXkiLCJpc0FycmF5IiwibGVuZ3RoIiwiaSIsIk1hdGgiLCJhYnMiLCJtYXgiXSwibWFwcGluZ3MiOiI7Ozs7O2tCQUV3QkEsTTtBQUZ4QixJQUFNQyxVQUFVLFFBQWhCOztBQUVlLFNBQVNELE1BQVQsQ0FBZ0JFLENBQWhCLEVBQW1CQyxDQUFuQixFQUFzQjtBQUNuQyxNQUFJQyxNQUFNQyxPQUFOLENBQWNILENBQWQsS0FBb0JFLE1BQU1DLE9BQU4sQ0FBY0YsQ0FBZCxDQUF4QixFQUEwQztBQUN4QyxRQUFJRCxNQUFNQyxDQUFWLEVBQWE7QUFDWCxhQUFPLElBQVA7QUFDRDtBQUNELFFBQUlELEVBQUVJLE1BQUYsS0FBYUgsRUFBRUcsTUFBbkIsRUFBMkI7QUFDekIsYUFBTyxLQUFQO0FBQ0Q7QUFDRCxTQUFLLElBQUlDLElBQUksQ0FBYixFQUFnQkEsSUFBSUwsRUFBRUksTUFBdEIsRUFBOEIsRUFBRUMsQ0FBaEMsRUFBbUM7QUFDakMsVUFBSSxDQUFDUCxPQUFPRSxFQUFFSyxDQUFGLENBQVAsRUFBYUosRUFBRUksQ0FBRixDQUFiLENBQUwsRUFBeUI7QUFDdkIsZUFBTyxLQUFQO0FBQ0Q7QUFDRjtBQUNELFdBQU8sSUFBUDtBQUNEO0FBQ0QsU0FBT0MsS0FBS0MsR0FBTCxDQUFTUCxJQUFJQyxDQUFiLEtBQW1CRixVQUFVTyxLQUFLRSxHQUFMLENBQVMsR0FBVCxFQUFjRixLQUFLQyxHQUFMLENBQVNQLENBQVQsQ0FBZCxFQUEyQk0sS0FBS0MsR0FBTCxDQUFTTixDQUFULENBQTNCLENBQXBDO0FBQ0QiLCJmaWxlIjoiZXF1YWxzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgRVBTSUxPTiA9IDAuMDAwMDAxO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBlcXVhbHMoYSwgYikge1xuICBpZiAoQXJyYXkuaXNBcnJheShhKSAmJiBBcnJheS5pc0FycmF5KGIpKSB7XG4gICAgaWYgKGEgPT09IGIpIHtcbiAgICAgIHJldHVybiB0cnVlO1xuICAgIH1cbiAgICBpZiAoYS5sZW5ndGggIT09IGIubGVuZ3RoKSB7XG4gICAgICByZXR1cm4gZmFsc2U7XG4gICAgfVxuICAgIGZvciAobGV0IGkgPSAwOyBpIDwgYS5sZW5ndGg7ICsraSkge1xuICAgICAgaWYgKCFlcXVhbHMoYVtpXSwgYltpXSkpIHtcbiAgICAgICAgcmV0dXJuIGZhbHNlO1xuICAgICAgfVxuICAgIH1cbiAgICByZXR1cm4gdHJ1ZTtcbiAgfVxuICByZXR1cm4gTWF0aC5hYnMoYSAtIGIpIDw9IEVQU0lMT04gKiBNYXRoLm1heCgxLjAsIE1hdGguYWJzKGEpLCBNYXRoLmFicyhiKSk7XG59XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./node_modules/viewport-mercator-project/dist/equals.js
// module id = 2318
// module chunks = 0